module.exports = __webpack_public_path__ + "img/granada.7342135c.jpg";